document.addEventListener('DOMContentLoaded', function() {

  /**
   * Handle line item _available property updates
   */
  function initializeLineItemPropertyHandling() {
    //console.log('Initializing line item property handling');
    // Find all availability inputs
    const availabilityInputs = document.querySelectorAll('input[data-key][name^="properties[_available_"]');
    //console.log('Found availability inputs:', availabilityInputs.length);
    
    availabilityInputs.forEach(input => {
      //console.log('Adding listeners to input:', input.getAttribute('data-key'));
      //console.log('Input type:', input.type);
      //console.log('Current value:', input.value);
      
      // Add both change and click handlers for better coverage
      input.addEventListener('change', handleAvailabilityChange);
      input.addEventListener('click', handleAvailabilityChange);
      
      // For checkbox/radio inputs, also listen for direct property changes
      if (input.type === 'checkbox' || input.type === 'radio') {
        Object.defineProperty(input, 'checked', {
          set: function(value) {
            this.setAttribute('checked', value);
            handleAvailabilityChange({ target: this });
          }
        });
      }
    });
  }

  /**
   * Handle individual availability change
   * @param {Event} event - The change event
   */
  async function handleAvailabilityChange(event) {
    const input = event.target;
    const key = input.getAttribute('data-key');
    let newValue;
    
    // Determine the new value based on input type
    if (input.type === 'checkbox' || input.type === 'radio') {
      newValue = input.checked.toString();
    } else {
      newValue = input.value;
    }

    //console.log('handleAvailabilityChange', {
    //  key,
    //  newValue,
    //  inputType: input.type,
    //  inputChecked: input.checked,
    //  inputValue: input.value
    //});

    try {
      // Get current cart state
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find the item and its line number (1-based index)
      const lineNumber = cart.items.findIndex(item => item.key === key) + 1;
      if (lineNumber === 0) {
        console.error('Cart item not found:', key);
        return;
      }

      // Keep existing properties and update _available
      const currentItem = cart.items[lineNumber - 1];
      const updatedProperties = {
        ...currentItem.properties,
        _available: newValue
      };

      //console.log('Updating cart item:', {
      //  line: lineNumber,
      //  properties: updatedProperties
      //});

      // Update the line item properties
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: currentItem.variant_id,
          quantity: currentItem.quantity,
          properties: updatedProperties
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update cart item property');
      }

      const responseData = await response.json();
      //console.log('Cart update response:', responseData);

      // Trigger cart update to refresh the UI
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'line-item-properties' });

    } catch (error) {
      console.error('Error updating item availability:', error);
      // Revert the input to its previous state
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = !input.checked;
      } else {
        input.value = input.value === 'true' ? 'false' : 'true';
      }
    }
  }

  // Initialize line item property handling after a short delay to ensure DOM is ready
  setTimeout(initializeLineItemPropertyHandling, 500);

  /**
   * Collect cart-level attributes from inputs (e.g., checkboxes, radios, texts).
   */
  function collectCartAttributes() {
    const attributes = {};
    document.querySelectorAll('[name^="attributes["]').forEach(input => {
      const match = input.name.match(/attributes\[(.*?)\]/);
      if (!match) return;
      const attributeName = match[1];
      if (input.type === 'checkbox') {
        attributes[attributeName] = input.checked ? 'kyllä' : 'ei';
      } else if (input.type === 'radio') {
        if (input.checked) attributes[attributeName] = input.value;
      } else {
        attributes[attributeName] = input.value;
      }
    });
    return attributes;
  }

  /**
   * Collect storage attributes from inputs with IDs starting with "storage-".
   */
  function collectStorageAttributes() {
    const storageAttributes = {};
    document.querySelectorAll('input[id^="storage-"]').forEach(input => {
      if (input.value) {
        const id = input.getAttribute('data-id');
        storageAttributes[`storage_${id}`] = input.value;
      }
    });
    return storageAttributes;
  }

  /**
   * On cart form submission, merge cart-level attributes and update the cart.
   * Then redirect the user to checkout.
   */
  const cartForm = document.getElementById('cart');
  if (cartForm) {
    cartForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      const updatedAttributes = Object.assign(
        {},
        collectCartAttributes(),
        collectStorageAttributes()
      );
      const attributePayload = { attributes: updatedAttributes };

      const attributeResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(attributePayload)
      });
      if (!attributeResponse.ok) {
        console.error('Failed to update cart attributes');
        return;
      }
      window.location.href = '/checkout';
    });
  }

  /**
   * Update a single cart item's properties
   */
  async function updateCartItemProperty(line, quantity, properties) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: properties.id,
          quantity: quantity,
          properties: {
            _available: properties._available
          }
        })
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(`Failed to update item ${line}:`, error);
      throw error;
    }
  }

  // Subscribe to cart update events to maintain _available properties
  subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
    // Avoid processing our own updates
    if (event.source === 'line-item-properties') return;

    try {
      // Update cart attributes regardless of source
      const updatedAttributes = Object.assign(
        {},
        collectCartAttributes(),
        collectStorageAttributes()
      );
      
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: updatedAttributes })
      });

      // Get current cart state
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) throw new Error('Failed to fetch cart');
      const cart = await cartResponse.json();

      // Process each item sequentially, including campaign gifts
      for (let index = 0; index < cart.items.length; index++) {
        const item = cart.items[index];
        const input = document.querySelector(`input[data-key="${encodeURIComponent(item.key)}"][name^="properties[_available_"]`);
        
        // For campaign gifts, set _available to true if input is missing
        if (!input && event.source === 'cart-campaigns') {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                line: index + 1,
                quantity: item.quantity,
                properties: {
                  _available: 'true'
                }
              })
            });
          } catch (error) {
            console.error('Failed to update campaign gift:', error);
            continue;
          }
          continue;
        }

        if (!input) continue;

        // Only update if property is missing or different
        if (!item.properties || item.properties._available !== input.value) {
          try {
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                line: index + 1,
                quantity: item.quantity,
                properties: {
                  _available: input.value
                }
              })
            });

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
          } catch (error) {
            console.error('Failed to update item:', error);
            continue;
          }
        }
      }
    } catch (error) {
      console.error('Error in cart update handler:', error);
    }

    // validate pharmaceutical selections
    if (window.na && typeof window.na.validatePharmaceuticalSelections === 'function') {
      window.na.validatePharmaceuticalSelections();
    }
    // check medicine restriction
    if (typeof _checkMedicineRestriction === 'function') {
      _checkMedicineRestriction();
    }
  });

  // Trigger cart update event when page loads
  setTimeout(() => {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'page-load' });
  }, 500);

});
